import React, { useState } from 'react'
import { Cell, DataBlock, Divider, Expander, ExpanderContent, ExpanderHeader, Grid, H5 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function OdmIndividualSource({ source }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  return (
    <>
      <Divider marginY="nano" />
      <Expander open={open} setOpen={setOpen}>
        <ExpanderHeader>
          <H5>{t('odm.source', 'Individual Source')}</H5>
        </ExpanderHeader>
        <ExpanderContent>
          <Divider marginY="nano" />
          {source && (
            <Grid>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.prcBatch', 'PRC Batch #')} data={source.processBatch} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.cofAddDate', 'COF Add Date')} data={source.cofAddDDate} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.igiDate', 'IGI Date')} data={source.igiDate} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.indEvent', 'Individual Event')} data={source.endEvt} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.marEvent', 'Marriage Event')} data={source.marEvt} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.memberID', 'Member ID')} data={source.memberId} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.batchType', 'Source Batch Type')} data={source.srcBatchType} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.batchNumber', 'Source Batch #')} data={source.srcBatch} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.sheetNumber', 'Sheet #')} data={source.sheet} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.serialNumber', 'Serial #')} data={source.serial} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.sourceRfn', 'Source RFN')} data={source.sourceRfn} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.documentType', 'Document Type')} data={source.docType} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.submitterRfn', 'Submitter RFN')} data={source.submitterRfn} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.addDate', 'Add Date')} data={source.addDate} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.source.releaseDate', 'Release Date')} data={source.relDate} />
              </Cell>
            </Grid>
          )}
          {!source && <p>{t('odm.noSource', 'No Source Information')}</p>}
          <Divider marginY="nano" />
        </ExpanderContent>
      </Expander>
    </>
  )
}
